export default "__VITE_ASSET__4adc84a4__"